// imports
import React, { useEffect } from 'react';
import { AnyAction } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

import { ICON } from '../../../assets';
import ItemHeader from '../../card/itemHeader';
import PrimaryButton from '../../button/primary';
import { fetchBackpackItems } from '../../../repositories/store/thunks';
import { selectUserBackpack } from '../../../repositories/store/slices';

// interfaces / types / consts
interface ItemsProps { items: string[]; disabled?: boolean }

// exports
export default function ItemDropdown(props: ItemsProps): JSX.Element {
  const { items, disabled } = props;
  // hooks configuration
  const dispatch = useDispatch();
  const { items: backpackItems, fetchStatus } = useSelector(selectUserBackpack);
  const headerItems = items?.map((itemId) => (<ItemHeader key={itemId} id={itemId} disabled={disabled} amount={backpackItems[itemId]} />)) || [];

  useEffect(() => { if (fetchStatus === 'idle') { dispatch(fetchBackpackItems() as unknown as AnyAction); } });

  // render
  return (
    <div className="item-dropdown-container">
      <div className="item-dropdown">
        <div className="items">
          <div className={headerItems.length > 1 ? 'desktop' : ''}>
            <div className="header-items">
              {headerItems}
            </div>
          </div>
          {headerItems.length > 1 && (
            <div className="mobile">
              <PrimaryButton
                text="Resources"
                disabled={disabled}
                toggleElem="dropdown"
                leftIcon={ICON.MAP_BACKPACK}
                rightIcon={ICON.DROPDOWN_ARROW}
                className="account-dropdown resource-dropdown"
              />
              <ul className="dropdown-body dropdown-menu dropdown-menu-end">
                {headerItems.map((item) => <li key={item.key}>{item}</li>)}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// default props
ItemDropdown.defaultProps = { disabled: false };
